export default [
  {
    title: 'Observability',
    gjIcon: 'Monitoring',
    children: [
      {
        title: 'Healthchecks',
        route: 'healthchecks',
      },
      {
        title: 'Alerts',
        route: 'alerts',
      },
      {
        title: 'Providers',
        route: 'providers',
      },
    ],
  },
]
